module.exports = __webpack_public_path__ + "static/img/php-41012.f339a954.png";